export const REPORT_CATEGORIES = [
  "All categories",
  "Sales",
  "Finance",
  "Inventory",
  "Marketing",
  "Fulfillment",
  "Operations",
];

const categoryById = {
  "sales-by-product": "Sales",
  "sales-by-product-by-day": "Sales",
  "sales-revenue": "Marketing",
  "sales-revenue-monthly": "Marketing",
  "total-product-revenue": "Sales",
  "shopify-profit-summary": "Marketing",
  "shopify-profit-by-sku-summary": "Marketing",
  "amazon-profit-summary": "Finance",
  "amazon-profit-by-sku-summary": "Finance",
  "monthly-ap-po-paid": "Finance",
  "monthly-po-ap-due": "Finance",
  "monthly-po-ap-progress": "Finance",
  "amazon-month-end-close-summary": "Finance",
  "qbo-change-ledger": "Finance",
  "eadin-cogs": "Finance",
  "received-inventory-value": "Finance",
  "received-shipments-reports": "Inventory",
  "warehouse-inventory-value": "Inventory",
  "warehouse-reconciliation": "Fulfillment",
  "bin-restocking-brief": "Fulfillment",
  "inbound-get-ready": "Fulfillment",
  "inbound-receiving-putaway": "Fulfillment",
  "inventory-cost-change": "Inventory",
  "missing-inventory-cost": "Inventory",
  "source-skus-by-product": "Operations",
  "max-discount-pricing": "Operations",
  "low-stock-alerts": "Inventory",
  "amazon-fba-low-stock-alerts": "Inventory",
  "inbound-shipments": "Fulfillment",
  "inbound-shipments-overview": "Fulfillment",
  "shipping-each-cost-change": "Operations",
  "fedex-billing-reconciliation": "Operations",
  "shiphero-label-cost": "Finance",
  "packaging-usage": "Finance",
  "billcom-po-balance-reconciliation": "Finance",
  "po-ledger-shadow": "Finance",
  "po-status-audit": "Finance",
  "closed-po-reconciliation": "Finance",
  "bom-packaging": "Operations",
  klaviyo_campaigns: "Marketing",
  klaviyo_campaign_performance: "Marketing",
  klaviyo_flows: "Marketing",
  klaviyo_flow_performance: "Marketing",
  klaviyo_lists: "Marketing",
  klaviyo_segments: "Marketing",
  klaviyo_metrics: "Marketing",
  klaviyo_metric_aggregates: "Marketing",
};

export function getReportCategory(report) {
  if (report?.category) {
    const value = String(report.category);
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  return categoryById[report?.id] || "Operations";
}

export function formatReportDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date);
}

export function formatRelativeDate(value) {
  if (!value) return "Never";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Never";
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.round(days / 30)} mo ago`;
  return `${Math.round(days / 365)} yr ago`;
}

export const REPORT_SORT_COLUMNS = {
  name: "name",
  category: "category",
  lastViewed: "lastViewed",
};

const DEFAULT_SORT_DIRECTION = {
  [REPORT_SORT_COLUMNS.name]: "asc",
  [REPORT_SORT_COLUMNS.category]: "asc",
  [REPORT_SORT_COLUMNS.lastViewed]: "desc",
};

export function getDefaultSortDirection(column) {
  return DEFAULT_SORT_DIRECTION[column] || "asc";
}

export function compareReportsByColumn(left, right, column, direction) {
  const dir = direction === "desc" ? -1 : 1;

  if (column === REPORT_SORT_COLUMNS.name) {
    return dir * String(left.name || "").localeCompare(String(right.name || ""), undefined, {
      sensitivity: "base",
    });
  }

  if (column === REPORT_SORT_COLUMNS.category) {
    return dir * String(left.category || "").localeCompare(String(right.category || ""), undefined, {
      sensitivity: "base",
    });
  }

  if (column === REPORT_SORT_COLUMNS.lastViewed) {
    const leftTime = left.lastViewed ? new Date(left.lastViewed).getTime() : 0;
    const rightTime = right.lastViewed ? new Date(right.lastViewed).getTime() : 0;
    return dir * (leftTime - rightTime);
  }

  return 0;
}
